export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2783fe4e79ba6429666ae13bb024c3ce2f44423c&name=fetchTypeahead!'